"use client";

import React from "react";

export interface BreadcrumbItem {
  id: string;
  name: string;
  driveId?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  onNavigate: (item: BreadcrumbItem) => void;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, onNavigate }) => {
  // On mobile, show only the last 2 items with "..." if there are more
  const shouldTruncate = items.length > 2;
  const displayItems = shouldTruncate ? items.slice(-2) : items;
  const hasMore = shouldTruncate && items.length > 2;

  return (
    <div className="flex items-center space-x-1 sm:space-x-2 text-xs sm:text-sm text-muted-foreground mb-4 overflow-x-auto">
      {hasMore && (
        <>
          <span className="text-muted-foreground/60">...</span>
          <span className="text-muted-foreground/60">/</span>
        </>
      )}
      {displayItems.map((item, index) => (
        <React.Fragment key={item.id}>
          {index > 0 && <span className="text-muted-foreground/60">/</span>}
          <button type="button"
            onClick={() => onNavigate(item)}
            className="hover:text-foreground transition-colors whitespace-nowrap max-w-[120px] sm:max-w-none truncate"
            title={item.name}
          >
            {item.name}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};
